enum DashboardActionTypes {
    SET_OPEN_CYCLE = 'Dashboard/SET_OPEN_CYCLE ',

    SET_SELECTED_DATE = 'Dashboard/SET_SELECTED_DATE',

    RESET_LAST_AFFECTED_ORDER = 'Dashboard/RESET_LAST_AFFECTED_ORDER',

    REQUEST_DASHBOARD = 'Dashboard/REQUEST_DASHBOARD',
    REQUEST_DASHBOARD_SUCCESS = 'Dashboard/REQUEST_DASHBOARD_SUCCESS',
    REQUEST_DASHBOARD_FAILURE = 'Dashboard/REQUEST_DASHBOARD_FAILURE',

    REQUEST_AVAILABLE_DAYS = 'Dashboard/REQUEST_AVAILABLE_DAYS',
    REQUEST_AVAILABLE_DAYS_SUCCESS = 'Dashboard/REQUEST_AVAILABLE_DAYS_SUCCESS',
    REQUEST_AVAILABLE_DAYS_FAILURE = 'Dashboard/REQUEST_AVAILABLE_DAYS_FAILURE',

    REQUEST_PRODUCT_ACCEPT = 'Dashboard/REQUEST_PRODUCT_ACCEPT',
    REQUEST_PRODUCT_ACCEPT_SUCCESS = 'Dashboard/REQUEST_PRODUCT_ACCEPT_SUCCESS',
    REQUEST_PRODUCT_ACCEPT_FAILURE = 'Dashboard/REQUEST_PRODUCT_ACCEPT_FAILURE',

    REQUEST_PRODUCT_DECLINE = 'Dashboard/REQUEST_PRODUCT_DECLINE',
    REQUEST_PRODUCT_DECLINE_SUCCESS = 'Dashboard/REQUEST_PRODUCT_DECLINE_SUCCESS',
    REQUEST_PRODUCT_DECLINE_FAILURE = 'Dashboard/REQUEST_PRODUCT_DECLINE_FAILURE',

    REQUEST_PRINT = 'Dashboard/REQUEST_PRINT',
    REQUEST_PRINT_SUCCESS = 'Dashboard/REQUEST_PRINT_SUCCESS',
    REQUEST_PRINT_FAILURE = 'Dashboard/REQUEST_PRINT_FAILURE',

    REQUEST_REPRINT = 'Dashboard/REQUEST_REPRINT',
    REQUEST_REPRINT_SUCCESS = 'Dashboard/REQUEST_REPRINT_SUCCESS',
    REQUEST_REPRINT_FAILURE = 'Dashboard/REQUEST_REPRINT_FAILURE',

    REQUEST_CREATE_LABELS = 'Dashboard/REQUEST_CREATE_LABELS',
    REQUEST_CREATE_LABELS_SUCCESS = 'Dashboard/REQUEST_CREATE_LABELS_SUCCESS',
    REQUEST_CREATE_LABELS_FAILURE = 'Dashboard/REQUEST_CREATE_LABELS_FAILURE',

    REQUEST_REMOVE_LABELS = 'Dashboard/REQUEST_REMOVE_LABELS',
    REQUEST_REMOVE_LABELS_SUCCESS = 'Dashboard/REQUEST_REMOVE_LABELS_SUCCESS',
    REQUEST_REMOVE_LABELS_FAILURE = 'Dashboard/REQUEST_REMOVE_LABELS_FAILURE',

    REQUEST_ORDER_STATUS_CHANGE = 'Dashboard/REQUEST_ORDER_STATUS_CHANGE',
    REQUEST_ORDER_STATUS_CHANGE_SUCCESS = 'Dashboard/REQUEST_ORDER_STATUS_CHANGE_SUCCESS',
    REQUEST_ORDER_STATUS_CHANGE_FAILURE = 'Dashboard/REQUEST_ORDER_STATUS_CHANGE_FAILURE',

    REQUEST_VEHICLE = 'Dashboard/REQUEST_VEHICLE',
    REQUEST_VEHICLE_SUCCESS = 'Dashboard/REQUEST_VEHICLE_SUCCESS',
    REQUEST_VEHICLE_FAILURE = 'Dashboard/REQUEST_VEHICLE_FAILURE',

    REQUEST_ORDER_GOT_IT = 'Dashboard/REQUEST_ORDER_GOT_IT',
    REQUEST_ORDER_GOT_IT_SUCCESS = 'Dashboard/REQUEST_ORDER_GOT_IT_SUCCESS',
    REQUEST_ORDER_GOT_IT_FAILURE = 'Dashboard/REQUEST_ORDER_GOT_IT_FAILURE',

    REQUEST_SETTINGS = 'Dashboard/REQUEST_SETTINGS',
    REQUEST_SETTINGS_SUCCESS = 'Dashboard/REQUEST_SETTINGS_SUCCESS',
    REQUEST_SETTINGS_FAILURE = 'Dashboard/REQUEST_SETTINGS_FAILURE',

    SET_FAILED_ORDER_ID = 'Dashboard/SET_FAILED_ORDER_ID',
    RESET_FAILED_ORDER_ID = 'Dashboard/RESET_FAILED_ORDER_ID',

    OPEN_CONFIRM_DIALOG = 'Dashboard/OPEN_CONFIRM_DIALOG',
    CLOSE_CONFIRM_DIALOG = 'Dashboard/CLOSE_CONFIRM_DIALOG',
    CONFIRM_ACCEPT_DECLINED_PRODUCT = 'Dashboard/CONFIRM_ACCEPT_DECLINED_PRODUCT',

    // custom
    RESTART_INTERVAL = 'Dashboard/RESTART_INTERVAL',
    
    // day transition
    DAY_TRANSITION_DETECTED = 'Dashboard/DAY_TRANSITION_DETECTED',
    DAY_TRANSITION_REFRESH = 'Dashboard/DAY_TRANSITION_REFRESH',

    // product loading states
    SET_PRODUCT_LOADING = 'Dashboard/SET_PRODUCT_LOADING',
}

export default DashboardActionTypes
